/**
 * Created by Ganesh.Sharma on 27-08-2016.
 */
/*
        CHG0032036 - Omega Integration with Melissa Data Service
        AB - 01/10/2019
*/

define(['underscore','text!./templates/standard-address.html'],
        (_,templateStr) => {
return ['AddressStandardizationService', '$q', 'ModalService', 'qnb.InputValidationService', (AddressStandardizationService, $q, ModalService,InputValidationService) => {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
                address : '=',
                readonly: '='
        },
        controller:['$scope', ($scope) => {
        $scope.showLoading = false;
        $scope.isNameValid = true;
        $scope.getStandardAddress = () => {
                    
        if ($scope.address.addressLine1.value && $scope.address.addressLine1.value.length > 0) {
                $scope.readonly = true;
                $scope.showLoading = true;
                $scope.State = '';

                $scope.standardAddressDetails = {
                streetAddress : $scope.address.addressLine1.value,
                        extendedAddress : $scope.address.addressLine2.value,
                        zipCode : $scope.address.postalCode.value.trim()
                };

                let inputsToValidate = [
                        {'addressLine1' : $scope.address.addressLine1.value},       
                        {'addressLine2' : $scope.address.addressLine2.value},
                        {'city' : $scope.address.city.value}
                ];
                inputValidationData = InputValidationService.isInputValid(inputsToValidate)
                if(!inputValidationData[0] && inputValidationData[1].length > 0){
                        for (let i=0; i<inputValidationData[1].length; i++){
                                $scope.address[inputValidationData[1][i]].value = ''
                                $scope.isNameValid = false;
                        }
                        return
                }else{
                        $scope.isNameValid = true;
                }

                $q.when(AddressStandardizationService.standardAddress('addressstandardization', $scope.standardAddressDetails),
                (AddressResponse) => {
                    switch (AddressResponse.addressErrorCode) {
                      case "Success":
                            var title = "We are able to validate your address, is this your correct address?"
                            var message2 = "We were unable to validate your address"
                            var validationMessage = "No, go back and edit"

                            if(null != AddressResponse.extendedAddress){
                            var address = AddressResponse.streetAddress + " " + AddressResponse.extendedAddress + " " + AddressResponse.city + " " + AddressResponse.state + " " + AddressResponse.zipCode;
                            }else {
                            var address = AddressResponse.streetAddress + " " + AddressResponse.city + " " + AddressResponse.state + " " + AddressResponse.zipCode;
                            }
                            var addressModel = ModalService.showMelissaSuccessPopup(title,address)
                            addressModel.result.then(function(result){
                            if(result.actionType=="yes"){
                                $scope.address.addressLine1.value = AddressResponse.streetAddress;
                                $scope.address.addressLine2.value = AddressResponse.extendedAddress;
                                $scope.address.city.value = AddressResponse.city.trim();
                                $scope.address.postalCode = AddressResponse.zipCode;
                                $scope.address.county = AddressResponse.county;
                                $scope.address.state.value  = AddressResponse.state
                                $scope.State = AddressResponse.state;
                            }else{
                              $scope.readonly = false;
                             //$scope.State = $scope.address.state.value
                             }
                            }, function(){
                            })
                          break
                      case "Warning":
                            var title = "We are unable to validate your address with the US Postal Service"
                            var message = AddressResponse.addressErrorDesc
                            var continueModel = ModalService.showMelissaWarningPopup(title, message);
                            continueModel.result.then(function(){}, function(){})
                            //Author: Devnandan : Mandatory County Enhancement: If address standardization fails, pull county from ZipCodeToCountyMapping table
                            $scope.address.county.value = AddressResponse.county;;
                            $scope.readonly = false;
                          break
                      case "Error":
                            var title = "We are unable to validate your address with the US Postal Service"
                            var message = AddressResponse.addressErrorDesc
                            var continueModel = ModalService.showInfo(title, message);
                            continueModel.result.then(function(){}, function(){})
                            //Author: Devnandan : Mandatory County Enhancement: If address standardization fails, pull county from ZipCodeToCountyMapping table
                            $scope.address.county.value = AddressResponse.county;;
                            $scope.readonly = false;
                          break
                      default:
                        console.log("Melissa Service Handler Error ")
                     }
                    $scope.showLoading = false;
                },
                 () => {
                        //Something has gone legitimately wrong, let the user input the data manually
                        console.log("Melissa Service Error ")
                        $scope.readonly = false;
                        $scope.showLoading = false;
                });
        } else {
                $scope.readonly = false;
                $scope.address.city.value = '';
                $scope.address.county.value = '';
                $scope.address.state.value = undefined;
        }

        };
        }]
};
}];
        }
);


/** WEBPACK FOOTER **
 ** ./app/customer/js/src/edge/addressstandardization/directives/StandardAddress.js
 **/